import MediaLibraryPlugin from "components/TinyMCEPlugins/Plugins/MediaLibraryPlugin";
import { IntlShape } from "react-intl";
import { Editor } from "tinymce";

export type PluginRegistrationProps = {
  editor: Editor;
  intl?: IntlShape;
};

const RegisterPlugins = ({ ...props }: PluginRegistrationProps) => {
  /*Declare plugins here */
  MediaLibraryPlugin({ ...props });
};

export default RegisterPlugins;
